export const UPDATE_HEADER_TITLE = 'UPDATE_HEADER_TITLE'
export const SHOW_HEADER_LOGIN = 'SHOW_HEADER_LOGIN'
export const HIDE_HEADER_LOGIN = 'HIDE_HEADER_LOGIN'
export const SET_LAST_PROJET_ID = 'SET_LAST_PROJET_ID'
export const RESET_LAST_PROJET_ID = 'RESET_LAST_PROJET_ID'
export const TOGGLE_ARCHIVED = 'TOGGLE_ARCHIVED'

// App state
export const SELECT_TRAP = 'SELECT_TRAP'
export const SELECT_GROUP = 'SELECT_GROUP'
export const SELECT_ORGANISATION = 'SELECT_ORGANISATION'
export const VIEW_USER_DETAILS = 'VIEW_USER_DETAILS'
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'

// Popovers + Toasts
export const SHOW_POPOVER = 'SHOW_POPOVER'
export const HIDE_POPOVER = 'HIDE_POPOVER'
export const SHOW_TOAST = 'SHOW_TOAST'
export const HIDE_TOAST = 'HIDE_TOAST'

// Maps
export const RESET_MAP = 'RESET_MAP'
export const FOCUS_TRAP = 'FOCUS_TRAP'
export const FOCUS_GROUP = 'FOCUS_GROUP'
export const TOGGLE_HEATMAP = 'TOGGLE_HEATMAP'
export const API_GET_MAP_TRAPS_REQUEST = 'API_GET_MAP_TRAPS_REQUEST'
export const API_GET_MAP_TRAPS_SUCCESS = 'API_GET_MAP_TRAPS_SUCCESS'
export const API_GET_MAP_TRAPS_ERROR = 'API_GET_MAP_TRAPS_ERROR'

// User
export const API_CREATE_USER_REQUEST = 'API_CREATE_USER_REQUEST'
export const API_CREATE_USER_SUCCESS = 'API_CREATE_USER_SUCCESS'
export const API_CREATE_USER_ERROR = 'API_CREATE_USER_ERROR'
export const API_EDIT_USER_REQUEST = 'API_EDIT_USER_REQUEST'
export const API_EDIT_USER_SUCCESS = 'API_EDIT_USER_SUCCESS'
export const API_EDIT_USER_ERROR = 'API_EDIT_USER_ERROR'
export const API_EDIT_PASSWORD_REQUEST = 'API_EDIT_PASSWORD_REQUEST'
export const API_EDIT_PASSWORD_SUCCESS = 'API_EDIT_PASSWORD_SUCCESS'
export const API_EDIT_PASSWORD_ERROR = 'API_EDIT_PASSWORD_ERROR'

// People
export const API_GET_APPROVED_PEOPLE_REQUEST = 'API_GET_APPROVED_PEOPLE_REQUEST'
export const API_GET_APPROVED_PEOPLE_SUCCESS = 'API_GET_APPROVED_PEOPLE_SUCCESS'
export const API_GET_APPROVED_PEOPLE_ERROR = 'API_GET_APPROVED_PEOPLE_ERROR'
export const API_GET_PEOPLE_REQUESTS_REQUEST = 'API_GET_PEOPLE_REQUESTS_REQUEST'
export const API_GET_PEOPLE_REQUESTS_SUCCESS = 'API_GET_PEOPLE_REQUESTS_SUCCESS'
export const API_GET_PEOPLE_REQUESTS_ERROR = 'API_GET_PEOPLE_REQUESTS_ERROR'
export const API_ACCEPT_REQUESTS_REQUEST = 'API_ACCEPT_REQUESTS_REQUEST'
export const API_ACCEPT_REQUESTS_SUCCESS = 'API_ACCEPT_REQUESTS_SUCCESS'
export const API_ACCEPT_REQUESTS_ERROR = 'API_ACCEPT_REQUESTS_ERROR'
export const API_DENY_REQUESTS_REQUEST = 'API_DENY_REQUESTS_REQUEST'
export const API_DENY_REQUESTS_SUCCESS = 'API_DENY_REQUESTS_SUCCESS'
export const API_DENY_REQUESTS_ERROR = 'API_DENY_REQUESTS_ERROR'


// Organisation
export const API_GET_ORGANISATIONS_REQUEST = 'API_GET_ORGANISATIONS_REQUEST'
export const API_GET_ORGANISATIONS_SUCCESS = 'API_GET_ORGANISATIONS_SUCCESS'
export const API_GET_ORGANISATIONS_ERROR = 'API_GET_ORGANISATIONS_ERROR'
export const API_CREATE_ORGANISATION_REQUEST = 'API_CREATE_ORGANISATION_REQUEST'
export const API_CREATE_ORGANISATION_SUCCESS = 'API_CREATE_ORGANISATION_SUCCESS'
export const API_CREATE_ORGANISATION_ERROR = 'API_CREATE_ORGANISATION_ERROR'
export const API_UPDATE_ORGANISATION_REQUEST = 'API_UPDATE_ORGANISATION_REQUEST'
export const API_UPDATE_ORGANISATION_SUCCESS = 'API_UPDATE_ORGANISATION_SUCCESS'
export const API_UPDATE_ORGANISATION_ERROR = 'API_UPDATE_ORGANISATION_ERROR'

// Organisation Code
export const API_GET_ORGANISATION_CODE_REQUEST = 'API_GET_ORGANISATION_CODE_REQUEST'
export const API_GET_ORGANISATION_CODE_SUCCESS = 'API_GET_ORGANISATION_CODE_SUCCESS'
export const API_GET_ORGANISATION_CODE_ERROR = 'API_GET_ORGANISATION_CODE_ERROR'
export const API_CREATE_ORGANISATION_CODE_REQUEST = 'API_CREATE_ORGANISATION_CODE_REQUEST'
export const API_CREATE_ORGANISATION_CODE_SUCCESS = 'API_CREATE_ORGANISATION_CODE_SUCCESS'
export const API_CREATE_ORGANISATION_CODE_ERROR = 'API_CREATE_ORGANISATION_CODE_ERROR'
export const API_DELETE_ORGANISATION_CODE_REQUEST = 'API_DELETE_ORGANISATION_CODE_REQUEST'
export const API_DELETE_ORGANISATION_CODE_SUCCESS = 'API_DELETE_ORGANISATION_CODE_SUCCESS'
export const API_DELETE_ORGANISATION_CODE_ERROR = 'API_DELETE_ORGANISATION_CODE_ERROR'
export const API_CREATE_GROUP_INVITATION_REQUEST = 'API_CREATE_GROUP_INVITATION_REQUEST'
export const API_CREATE_GROUP_INVITATION_SUCCESS = 'API_CREATE_GROUP_INVITATION_SUCCESS'
export const API_CREATE_GROUP_INVITATION_ERROR = 'API_CREATE_GROUP_INVITATION_ERROR'

// Groups
export const API_GET_GROUPS_REQUEST = 'API_GET_GROUPS_REQUEST'
export const API_GET_GROUPS_SUCCESS = 'API_GET_GROUPS_SUCCESS'
export const API_GET_GROUPS_ERROR = 'API_GET_GROUPS_ERROR'
export const API_CREATE_GROUP_REQUEST = 'API_CREATE_GROUP_REQUEST'
export const API_CREATE_GROUP_SUCCESS = 'API_CREATE_GROUP_SUCCESS'
export const API_CREATE_GROUP_ERROR = 'API_CREATE_GROUP_ERROR'
export const API_UPDATE_GROUP_REQUEST = 'API_UPDATE_GROUP_REQUEST'
export const API_UPDATE_GROUP_SUCCESS = 'API_UPDATE_GROUP_SUCCESS'
export const API_UPDATE_GROUP_ERROR = 'API_UPDATE_GROUP_ERROR'
export const API_DELETE_GROUP_REQUEST = 'API_DELETE_GROUP_REQUEST'
export const API_DELETE_GROUP_SUCCESS = 'API_DELETE_GROUP_SUCCESS'
export const API_DELETE_GROUP_ERROR = 'API_DELETE_GROUP_ERROR'

// Traps 
export const API_GET_TRAPS_REQUEST = 'API_GET_TRAPS_REQUEST'
export const API_GET_TRAPS_SUCCESS = 'API_GET_TRAPS_SUCCESS'
export const API_GET_TRAPS_ERROR = 'API_GET_TRAPS_ERROR'
export const API_UPDATE_TRAP_REQUEST = 'API_UPDATE_TRAP_REQUEST'
export const API_UPDATE_TRAP_SUCCESS = 'API_UPDATE_TRAP_SUCCESS'
export const API_UPDATE_TRAP_ERROR = 'API_UPDATE_TRAP_ERROR'

// Data
export const API_GET_OVERVIEW_DATA_REQUEST = 'API_GET_OVERVIEW_DATA_REQUEST'
export const API_GET_OVERVIEW_DATA_SUCCESS = 'API_GET_OVERVIEW_DATA_SUCCESS'
export const API_GET_OVERVIEW_DATA_ERROR = 'API_GET_OVERVIEW_DATA_ERROR'

// User + Session
export const API_LOGIN_REQUEST = 'API_LOGIN_REQUEST'
export const API_LOGIN_SUCCESS = 'API_LOGIN_SUCCESS'
export const API_LOGIN_ERROR = 'API_LOGIN_ERROR'
export const API_LOGOUT_REQUEST = 'API_LOGOUT_REQUEST'
export const API_LOGOUT_SUCCESS = 'API_LOGOUT_SUCCESS'
export const API_LOGOUT_ERROR = 'API_LOGOUT_ERROR'
export const API_GET_USER_REQUEST = 'API_GET_USER_REQUEST'
export const API_GET_USER_SUCCESS = 'API_GET_USER_SUCCESS'
export const API_GET_USER_ERROR = 'API_GET_USER_ERROR'
export const API_RESET_REQUEST_REQUEST = 'API_RESET_REQUEST_REQUEST'
export const API_RESET_REQUEST_SUCCESS = 'API_RESET_REQUEST_SUCCESS'
export const API_RESET_REQUEST_ERROR = 'API_RESET_REQUEST_ERROR'
export const API_RESET_PASSWORD_REQUEST = 'API_RESET_PASSWORD_REQUEST'
export const API_RESET_PASSWORD_SUCCESS = 'API_RESET_PASSWORD_SUCCESS'
export const API_RESET_PASSWORD_ERROR = 'API_RESET_PASSWORD_ERROR'

// Email
export const API_SEND_VERIFY_EMAIL_REQUEST = 'API_SEND_VERIFY_EMAIL_REQUEST'
export const API_SEND_VERIFY_EMAIL_SUCCESS = 'API_SEND_VERIFY_EMAIL_SUCCESS'
export const API_SEND_VERIFY_EMAIL_ERROR = 'API_SEND_VERIFY_EMAIL_ERROR'
export const API_VERIFY_EMAIL_REQUEST = 'API_VERIFY_EMAIL_REQUEST'
export const API_VERIFY_EMAIL_SUCCESS = 'API_VERIFY_EMAIL_SUCCESS'
export const API_VERIFY_EMAIL_ERROR = 'API_VERIFY_EMAIL_ERROR'

// Invites
export const API_CHECK_TOKEN_REQUEST = 'API_CHECK_TOKEN_REQUEST'
export const API_CHECK_TOKEN_SUCCESS = 'API_CHECK_TOKEN_SUCCESS'
export const API_CHECK_TOKEN_ERROR = 'API_CHECK_TOKEN_ERROR'



// WEBPACK FOOTER //
// ./src/constants/actions.js